module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('washington-map', {
    attrs: {
      "mapFile": "wa.counties.json",
      "dataFile": "wa_load.csv",
      "res": "Grand Coulee/FDR Lake",
      "resFile": "wa.json",
      "whichState": "WA"
    }
  }), _vm._v(" "), _c('snow-chart', {
    attrs: {
      "whichState": "WA"
    }
  }), _vm._v(" "), _c('drought-map', {
    attrs: {
      "mapFile": "wa.counties.json",
      "centersFile": "wa_centers.json",
      "dataFile": "wa-counties.csv"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5aa55f66"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Washington.vue
// module id = 377
// module chunks = 1